import React, { Component } from 'react';
import './v2Wizard.less';
import { Button, Icon } from 'b3';
import moment from 'moment';
import { connect } from 'react-redux';
import ActionButtonsSlider from './ActionButtonsSlider';
import { closeWizard, showCompletedSuccessScreen, completeWizard, goBackInAction, openStackedStep, closeStackedStep } from './logActivityReducer';
import StackedStep from './StackedStep';
import ScheduledCallIcon from './ScheduledCallIcon';
import ScheduledMeetingIcon from './ScheduledMeetingIcon';

@connect(
	state => ({
		HubComponent: state.logActivityWizard.HubComponent,
        actionStepIndex: state.logActivityWizard.actionStepIndex,
        actionsSteps: state.logActivityWizard.actionsSteps,
        showStackedStep: state.logActivityWizard.showStackedStep,
        stackedStepComponent: state.logActivityWizard.stackedStepComponent,
        scheduledCalls: state.logActivityWizard.scheduledCallData,
        scheduledMeetings: state.logActivityWizard.scheduledMeetingData,
	}),
	{ closeWizard, showCompletedSuccessScreen, completeWizard, goBackInAction, openStackedStep, closeStackedStep }
)
class ScrollContent extends Component {
    state = {
        activeSlide: 0,
        fadeDown: false,
        date: moment(),
        show: false,
        showSuccess: false,
        showScheduleCall: false,
        isTranOpen: false,
        scheduledCalls: []
    }
    goBack = () => {
        this.props.goBackInAction();
    }
    updateTime = () => {}
    updateDate = () => {}
    onScroll = (e) => {
    	e.stopPropagation();
    }
    completeWizard = () => {
    	this.props.completeWizard();
    }
    render() {
    	var {
            height,
            width,
            HubComponent,
            actionStepIndex,
            actionsSteps,
            showStackedStep,
            stackedStepComponent,
            scheduledCalls,
            scheduledMeetings
        } = this.props;
        
        return (
        	<div style={{position: 'relative'}}>
        		<StackedStep
                    isOpen={showStackedStep} 
                    Component={stackedStepComponent} />

	            <div className="wizardScrollContainer"
	            	onScroll={this.onScroll}
	            	ref={el => this.scrollContainer = el} 
	            	style={{height, width}}>
	            	<div className="goBackWizardButtonWrapper" style={{opacity: actionStepIndex > 0 ? 1 : 0}}>
                        <div className="scheduled-activity-icons">
                            {! showStackedStep && scheduledCalls.filter(c => !c.cancel).map((s, i) =>
                                <ScheduledCallIcon key={i} />
                            )}
                            {! showStackedStep && scheduledMeetings.filter(c => !c.cancel).map((s, i) =>
                                <ScheduledMeetingIcon key={i} />
                            )}
                        </div>
	            		<Button className="goBackWizardButton" tabIndex={4} onClick={this.goBack}>
	            		    <Icon icon="arrow-2" /> Back
	            		</Button>
	            	</div>

                    <HubComponent />
                    
                    {actionsSteps.length > 0 &&
                        <ActionButtonsSlider 
                          height={250} 
                          width={width - 50} 
                          slide={actionsSteps[actionStepIndex]} />
                    }

                    
	            </div>
	        </div>
        );
    }
}


export default class ScrollTest extends Component {
    state = {
        scrollTop: 0
    };
    componentDidMount() {
        // update scrollTop to be scrollHeight
        window.moveDown = () => {
            this.setState({
                scrollTop: this.state.scrollTop + 220
            });
        }
    }
    render() {
    	var { height, width } = this.props;
        var { scrollTop } = this.state;

        return (
            <ScrollContent 
                height={height}
                width={width}
                scrollTop={scrollTop} />
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/schedule-wizard/V2Wizard.js